import { render, staticRenderFns } from "./course-transport.vue?vue&type=template&id=7c901bbc&scoped=true&"
import script from "./course-transport.vue?vue&type=script&lang=js&"
export * from "./course-transport.vue?vue&type=script&lang=js&"
import style0 from "./course-transport.vue?vue&type=style&index=0&id=7c901bbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c901bbc",
  null
  
)

export default component.exports